import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_48: FaireProductEntity = {
  token: "catalog_prod_prod-48",
  type: "product",
  name: "Woven Rattan Storage Basket",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 29.81,
  msrpDollars: 74.52,
  sku: "JA0048",
  caseSize: 12,
  material: "Wood",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 222,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
